import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stat" }
const _hoisted_2 = { class: "remaining-time" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, " 🍅 ", -1)
const _hoisted_4 = { class: "info-value" }
const _hoisted_5 = { class: "stat" }
const _hoisted_6 = { class: "remaining-time" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "info-label" }, " 🎯 ", -1)
const _hoisted_8 = { class: "info-value" }

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'StatistiquesBlock',
  props: {
  goal: {
    type: Number,
    required: true
  },
  currentPomodoroNumber: {
    type: Number,
    required: true
  },
  pomodoriByCycle: {
    type: Number,
    required: true
  },
  totalPomodoriDone: {
    type: Number,
    required: true
  }
  // timer: {
  //   type: String,
  //   required: true
  // }
},
  setup(__props) {

const props = __props;




const timeBeforeBigBreak = computed(() => { return null })
/*
const timeBeforeGoal = computed(() => {
  const seconds = 0
  if (props.pomodoroTime.minutes !== undefined && props.pomodoroTime.seconds !== undefined) {
    // const timerSeconds = parseInt(this.timer.slice(0, 2) * 60) + parseInt(this.timer.slice(-2))
    // console.log(timerSeconds);
    // seconds = timerSeconds + (this.goal - 1) * (this.pomodoroTime.minutes * 60 + this.pomodoroTime.seconds) + (this.goal - 1) * (this.breakTime.small.minutes * 60 + this.breakTime.small.seconds) + (Math.floor(this.goal / this.pomodoriByCycle)) * (this.breakTime.big.minutes * 60 + this.breakTime.big.seconds)
  }
  return seconds / 60
})
*/
const goalStat = computed(() => {
  return props.totalPomodoriDone + (props.goal !== 0 ? ' / ' + props.goal : '')
})

const cycleStat = computed(() => {
  return props.currentPomodoroNumber + ' / ' + props.pomodoriByCycle
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(timeBeforeBigBreak.value), 1),
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(cycleStat.value), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(), 1),
      _hoisted_7,
      _createElementVNode("span", _hoisted_8, _toDisplayString(goalStat.value), 1)
    ])
  ]))
}
}

})